import { c as _c } from "react/compiler-runtime";
import { EntityUtils } from '@record-it-npm/synchro-client';
import React, { ComponentProps, FunctionComponent } from 'react';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { WorkTimeEntry } from '../../../classes/entities/WorkTimeEntry/workTimeEntryTypes';
import { WorkTimeEntryListItem } from '../WorkTimeEntryListItem/WorkTimeEntryListItem';
export type WorkTimeEntryListProps = PropsWithoutChildren<ComponentProps<'div'>> & {
  workTimeEntries: Array<WorkTimeEntry>;
};
export const WorkTimeEntryList: FunctionComponent<WorkTimeEntryListProps> = React.memo(props => {
  const $ = _c(6);
  let t0;
  let t1;
  if ($[0] !== props) {
    const {
      workTimeEntries,
      ...remainingProps
    } = prepareProps({
      props,
      ignoreChildren: true
    });
    t0 = remainingProps;
    t1 = workTimeEntries.map(_temp);
    $[0] = props;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0 || $[4] !== t1) {
    t2 = <div {...t0}>{t1}</div>;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
});
function _temp(wte) {
  return <WorkTimeEntryListItem key={EntityUtils.getTrackingKey(wte)} workTimeEntry={wte} data-testid="WorkTimeEntryList.ListItem" />;
}